import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { RedoRadioGroup } from "@redotech/arbiter/radio/redo-radio-group";
import { RedoSingleSelectDropdownInput } from "@redotech/arbiter/select-dropdown/redo-single-select-dropdown-input";
import { Text } from "@redotech/arbiter/text";
import { DiscountPurchaseType } from "@redotech/redo-discounts-common/discount/discount-db-parser";
import { LabeledInput, LabelSize } from "../../../labeled-input";
import { purchaseTypeOptions, recurringCycleLimitOptions } from "../constants";

export function PurchaseTypeField({
  purchaseType,
  setPurchaseType,
  recurringCycleLimit,
  setRecurringCycleLimit,
}: {
  purchaseType: DiscountPurchaseType | undefined;
  setPurchaseType: (value: DiscountPurchaseType) => void;
  recurringCycleLimit: number | undefined;
  setRecurringCycleLimit: (value: number | undefined) => void;
}) {
  return (
    <>
      <RedoSingleSelectDropdownInput<DiscountPurchaseType>
        label="Purchase type"
        options={purchaseTypeOptions}
        optionSelected={({ item }) => {
          setPurchaseType(item.value);
          if (item.value === DiscountPurchaseType.ONE_TIME) {
            setRecurringCycleLimit(undefined);
          }
        }}
        selectedItem={purchaseTypeOptions.find(
          (o) => o.value === (purchaseType ?? DiscountPurchaseType.ONE_TIME),
        )}
        size="xs"
      />
      {purchaseType && purchaseType !== DiscountPurchaseType.ONE_TIME && (
        <LabeledInput
          label={
            <Text fontSize="xs" fontWeight="medium" textColor="secondary">
              Recurring payments for subscriptions
            </Text>
          }
          size={LabelSize.EXTRA_SMALL}
        >
          <RedoRadioGroup
            options={recurringCycleLimitOptions}
            setValue={(value) => {
              switch (value) {
                case "first":
                  setRecurringCycleLimit(1);
                  break;
                case "multiple":
                  setRecurringCycleLimit(
                    recurringCycleLimit && recurringCycleLimit > 1
                      ? recurringCycleLimit
                      : 2,
                  );
                  break;
                case "all":
                  setRecurringCycleLimit(undefined);
                  break;
              }
            }}
            value={
              recurringCycleLimit === undefined
                ? "all"
                : recurringCycleLimit === 1
                  ? "first"
                  : "multiple"
            }
          />
          {recurringCycleLimit !== undefined && recurringCycleLimit > 1 && (
            <RedoTextInput
              fullWidth
              inputTypeHint="number"
              label="Number of recurring payments"
              placeholder="Number of payments"
              setValue={(value) =>
                setRecurringCycleLimit(value ? Math.max(2, Number(value)) : 2)
              }
              value={recurringCycleLimit.toString()}
            />
          )}
        </LabeledInput>
      )}
    </>
  );
}
